// extracted by mini-css-extract-plugin
module.exports =  {"content":"_32bbee5fda--content--_HCDR","link":"_32bbee5fda--link--fiPtb"};